export default __webpack_public_path__ + "static/logo-58e4a0b7adafd61efb56b485f597112d.png";